import apiService from '../api.service';

class DashboardAnalyticsService {
  public async getDashboardAnalytics(startDate: string, endDate: string) {
    return apiService.get('/analytics/dashboard', {
      params: {
        startDate,
        endDate,
      },
    });
  }
}

export default new DashboardAnalyticsService();
